import { HomePage, TasksPage, ProfilePage, UploadPage, Help} from './pages';
import { withNavigationWatcher } from './contexts/navigation';
import Pwa from "./pages/pwa/pwa";
import Dashboards from "./pages/dashboard/dashboard";
import Linkprov from "./pages/tools/linkprov/linkprov";
import Provxlsx from "./pages/tools/provxlsx/provxlsx";
import Opros from "./pages/opros/opros";
import Opros26 from "./pages/opros/opros26";
const routes = [
    {
        path: '/tasks',
        element: TasksPage
    },
    {
        path: '/profile',
        element: ProfilePage
    },
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/upload',
        element: UploadPage
    },
    {
        path: '/help',
        element: Help
    },
    {
        path: '/pwa',
        element: Pwa
    },
    {
        path: '/dashboard',
        element: Dashboards
    },
    {
        path: '/linkprov',
        element: Linkprov
    },
    {
        path: '/provxlsx',
        element: Provxlsx
    },
    {
        path: '/opros25',
        element: Opros
    },
    {
        path: '/opros',
        element: Opros26
    },
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
